import type { KeycloakToken } from './KeycloakToken'

export type KeycloakUser = {
	/** Unique ID of user */
	id: string
	/** Unique username of user */
	username: string

	/**
	 * Pretty display-name. Name, email or username depending on
	 * avilability
	 */
	displayName: string
	/**
	 * Identifier for error logging. email or username depending on
	 * avilability
	 */
	logName: string

	name?: string
	email?: string

	roles: Array<string>
	groups: Array<string>
}

export const getKeycloakUser = ({
	sub: id,
	name,
	given_name,
	email,
	preferred_username,
	realm_access,
	resource_access,
	groups,
}: KeycloakToken): KeycloakUser => ({
	id,
	username: preferred_username,

	displayName: name || given_name || email || preferred_username,
	logName: email || preferred_username,

	name,
	email,

	roles: [
		...(realm_access?.roles ?? []).map((role) => `realm:${role}`),
		...Object.entries(resource_access ?? {}).flatMap(([resource, { roles }]) =>
			roles.map((role) => `${resource}:${role}`),
		),
	],
	groups: groups ?? [],
})
